import { round, sumBy } from 'lodash';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { UpdateCapitalActionFormValues } from '../../../hooks/useCapitalActionForm';
import aggregateActionsBreakdown from './useAggregateActionsBreakdown';

export default function useSyncActionsValues({
  actions,
  entryIndex,
}: {
  actions: Array<{
    id: string;
    uncalledAmountLcy: number;
    allocations: Array<{
      commitmentId: string;
      investorLabel: string;
      unpaidAllocationAmountLcy: number;
    }>;
  }>;
  entryIndex: number;
}) {
  const { setValue, getValues } =
    useFormContext<UpdateCapitalActionFormValues>();

  useEffect(() => {
    const currentActions = getValues(`entries.${entryIndex}.actions`);

    const updatedActions = actions.map((action) => {
      const currentAction = currentActions.find((ca) => ca.id === action.id);

      return {
        id: action.id,
        capitalBreakdown: currentAction?.capitalBreakdown?.length
          ? currentAction.capitalBreakdown
          : action.allocations.map((allocation) => ({
              commitmentId: allocation.commitmentId,
              amountLcy: round(allocation.unpaidAllocationAmountLcy, 2),
              fundsCalled: {
                fromCommitmentLcy: round(
                  allocation.unpaidAllocationAmountLcy,
                  2,
                ),
                fromRecallableDistributionLcy: 0,
              },
            })),
        totalAmountLcy: action.uncalledAmountLcy,
      };
    });

    setValue(`entries.${entryIndex}.actions`, updatedActions);
    setValue(
      `entries.${entryIndex}.capitalBreakdown`,
      aggregateActionsBreakdown(updatedActions),
    );

    setValue(
      `entries.${entryIndex}.totalAmountLcy`,
      round(sumBy(actions, 'uncalledAmountLcy'), 2),
    );
  }, [actions, entryIndex]);
}
